import { v4 as uuidv4 } from 'uuid';
import { securityGate } from "../../../../../lib";
import Form from "../../../../../components/base/forms/form";
import Api from "../../../../../lib/api";
import ServiceLocator from "../../../../../global/service-locator";
import {AnalyticsService} from "../../../../../services/analytics-service";

export default class FormPage {
	constructor($root, mainController) {
		/* Elements */
		this.$root = $root;

		this.sl = ServiceLocator.instance;

		/* Components */
		this.mainController = mainController;
		this.shouldUpdateHeight = false;

		/* Config */
		this.data = null;
	}

	init(switchPageCallback) {
		FormPage.prototype.switchPage = switchPageCallback;

		setTimeout(() => {
			this.shouldUpdateHeight = true;
		}, 300);

		this.data = this.mainController.getResult();
		this.setForm();

		/* FB Analytics data for backend */
		Api.sendFbEvent('AddToCart', {
			entryId: craft.page.coursesStatsConfig.entryId
		});
	}

	setForm() {
		const formConfig = {
			formId: 'quiz',
			uri: '/2.0/courses/registration',
			data: {
				type: this.mainController.isUserAuthenticated ? 'consultation' : 'quiz-consultation',
				city: craft.env.cityId,
				course: craft.page.courseDirectoryId,
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href,
			},
			shouldClose: false,
			subscriptions: [
				{
					event: 'beforeSubmit',
					callback: ({ detail }) => {
						const conversionId = uuidv4();
						const owoxUserId = costorage.get('ouid');

						this.mainController.form.addData({ conversionId });

						if (owoxUserId) {
							this.mainController.form.addData({ owoxUserId });
						}

						const dataLayerEventData = {
							event: this.mainController.form.data.type === 'consultation' ? 'free_consultation_form' :
								this.mainController.form.data.type === 'quiz-consultation' ? 'online_test_consultation' : 'online_test_form',
							formId: this.mainController.form.formId,
							phone: this.mainController.form.data.tel,
							email: this.mainController.form.data.email,
							conversion_id: conversionId
						};

						const $formTitle = this.mainController.form.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent(this.mainController.form.data.type === 'consultation' ? 'free_consultation_form' :
							this.mainController.form.data.type === 'quiz-consultation' ? 'online_test_consultation' : 'online_test_form', dataLayerEventData);

						if (this.mainController.isUserAuthenticated) {
							return;
						}

						this.userData = Object.assign({}, detail);

						const quizData = {
							ratio: this.data.ratio,
							answers: this.data.questionList,
							passGrade: this.data.quizPassGrade,
							quizId: this.mainController.config.entryId,
							quizTitle: this.mainController.getQuizTitle()
						}

						if (securityGate(this.mainController.config.extraSlug)) {
							quizData["quizExtraSlug"] = this.mainController.config.extraSlug;
						}

						if (this.sl.courseLang) {
							quizData.courseLang = this.sl.courseLang;
						}

						try	{
							this.mainController.form.addData(quizData);
						} catch (err) {
							console.error('Quiz Form:', err);
						}
					}
				},
				{
					event: 'submitComplete',
					callback: () => {
						if (this.mainController.isUserAuthenticated) {
							this.mainController.sl.modalService.close();

							if (craft.page.quiz.items.length === 1) {
								this.mainController.init(() => {
									this.switchPage('initial', 2);
									setTimeout(() => {
										this.mainController.toggleProgressOverlay('hide');
									}, 1000);
								}, craft.page.quiz.items[0], true);
							} else {
								this.switchPage('initial', 1);
							}
						} else {
							this.mainController.finishQuiz(this.userData);
							this.switchPage();
							this.shouldUpdateHeight = false;
						}
					}
				},
				{
					field: 'getConsultation',
					event: 'timeSelectToggleVisibility',
					callback: ({ detail }) => {
						if (this.shouldUpdateHeight) {
							this.mainController.animation.updateHeight(null, false);
						}
					}
				}
			]
		};

		if (this.mainController.isUserAuthenticated) {
			const lmsUserData = this.mainController.sl.userDataService.lmsUserData;

			const formInitialValues = {};

			if (lmsUserData.first_name) {
				formInitialValues.name = lmsUserData.first_name;
			}

			if (lmsUserData.email) {
				formInitialValues.email = lmsUserData.email;
			}

			if (lmsUserData.phone) {
				formInitialValues.tel = lmsUserData.phone;
			}

			if (Object.keys(formInitialValues).length) {
				formConfig.initialValues = formInitialValues;
			}
		}

		try	{
			this.mainController.form = new Form(formConfig);
		} catch (err) {
			console.error('Consultation Form:', err);
		}
	}
}